import { View } from "./Reporting.view";

export const Container = () => {
  return <View />;
};
